<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="filters">
                <!--<el-form-item>
                    <el-select v-model="filters.userType" placeholder="请选择">
                        <el-option
                                v-for="item in userType"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>-->
                <!--<el-form-item>
                    <el-input v-model="filters.name" placeholder="姓名"></el-input>
                </el-form-item>-->
                <el-form-item>
                    <el-button type="primary" v-on:click="getUsers">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleAdd">新增</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-table :data="users" highlight-current-row border stripe v-loading="listLoading"
                  @selection-change="selsChange"
                  style="width: 100%;text-align: center">
            <el-table-column type="index" width="60">
            </el-table-column>
            <el-table-column prop="loginName" label="登录账号" width="100">
            </el-table-column>
            <el-table-column prop="userType" label="类型" width="90" :formatter="formatType">
            </el-table-column>
            <el-table-column prop="workNO" label="编号" width="110">
            </el-table-column>
            <el-table-column prop="phone" label="联系方式" width="125">
            </el-table-column>
            <el-table-column prop="name" label="姓名" width="100">
            </el-table-column>
            <el-table-column prop="money" label="余额" min-width="60">
            </el-table-column>
            <el-table-column prop="addTime" label="添加时间" min-width="120">
            </el-table-column>
            <el-table-column prop="address" label="地址" min-width="150">
            </el-table-column>

            <el-table-column label="操作" width="230">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="scope.row.userType==2" size="small" @click="editMoney(scope.$index, scope.row)">修改余额</el-button>
                    <el-button type="primary" size="small" @click="edit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="del(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <!--<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>-->
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="rowCount"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col>

        <!--编辑界面-->
        <el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="120px" ref="editForm">
                <el-form-item label="姓名">
                    <el-input v-model="editForm.name" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model="editForm.phone" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="editForm.email" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="地址">
                    <el-input v-model="editForm.address" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>

        <!--修改余额-->
        <el-dialog title="修改余额" v-model="editMoneyFormVisible" :close-on-click-modal="false">
            <el-form :model="editMoneyForm" label-width="120px" ref="editMoneyForm">
                <el-form-item label="金额">
                    <el-input v-model="editMoneyForm.money" placeholder='例:增加3元,输入:3 减少3元,输入:-3'auto-complete="off"></el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editMoneyFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editMoneySubmit">提交</el-button>
            </div>
        </el-dialog>

        <!--新增界面-->
        <el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="120px" ref="addForm">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="登录账号" class="require">
                            <el-input v-model="addForm.loginName" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="登录密码" class="require">
                            <el-input type="password" v-model="addForm.password" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="工号/商家编号" class="require">
                            <el-input v-model="addForm.workNO" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="用户类型" class="require">
                            <el-select v-model="addForm.userType" placeholder="请选择">
                                <el-option
                                        v-for="item in userType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="用户名称" class="require">
                            <el-input v-model="addForm.name" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系方式" class="require">
                            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="邮箱">
                            <el-input v-model="addForm.email" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址">
                            <el-input v-model="addForm.address" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";

    export default {
        data() {
            return {
                filters: {
                    name: '',
                    userType: ''
                },
                users: [],
                total: 0,
                rowCount: 20,
                pageNO: 1,
                userType: data.userType,
                listLoading: false,
                sels: [],

                editFormVisible: false,
                editLoading: false,
                editForm: {
                    userId: '',
                    name: '',
                    phone: '',
                    email: '',
                    address: ''

                },

                addFormVisible: false,
                addLoading: false,
                addForm: {
                    userType: '',
                    loginName: '',
                    password: '',
                    workNO: '',
                    name: '',
                    phone: '',
                    email: '',
                    address: ''

                },

                editMoneyFormVisible:false,
                editMoneyLoading:false,
                editMoneyForm:{
                    userId:'',
                    money:''
                }


            }
        },
        methods: {

            formatType: function (row, column) {
                switch (parseInt(row.userType)) {
                    case 0:
                        return '管理员';
                    case 1:
                        return '员工';
                    case 2:
                        return '商家';
                    case 3:
                        return '安装人员';
                    case 4:
                        return '用户';
                    default:
                        '未知类型';
                }

            },

            handleCurrentChange(val) {
                this.pageNO = val;
                this.getUsers();
            },


            getUsers() {
                let para = {
                    rowCount: this.rowCount,
                    pageNO: this.pageNO
                };
                Object.assign(para, this.filters);
                this.listLoading = true;
                NProgress.start();
                let url = 'user/getByUserTypePage.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        this.total = res.total;
                        this.users = res.data;
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },

            getuserById(id) {
                let para = {userId: id};
                this.listLoading = true;
                NProgress.start();
                let url = 'user/getUserInfo.do';
                requestPost(this, url, para).then((res) => {
                    if (res != '') {
                        this.total = 1;
                        this.users.push(res.data);
                    }
                    this.listLoading = false;
                    NProgress.done();
                });
            },

            //删除
            del: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    NProgress.start();
                    let para = {userId: row.userId};
                    let url = 'user/del.do';
                    requestPost(this, url, para).then((res) => {
                        this.listLoading = false;
                        NProgress.done();
                        if (res != '') {
                            this.filters.userType = row.userType;
                            util.successTip(this);
                            this.getUsers();
                        }
                    });
                }).catch(() => {

                });
            },
            //显示编辑界面
            edit: function (index, row) {
                this.editFormVisible = true;
                this.editForm = Object.assign({}, row);
            },
            editMoney:function(index,row){
                this.editMoneyFormVisible = true;
                this.editMoneyForm.userId = row.userId;
            },
            //显示新增界面
            handleAdd: function () {
                this.addFormVisible = true;
            },
            //编辑
            editMoneySubmit: function () {
                this.$confirm('确认提交吗？', '提示', {}).then(() => {

                    NProgress.start();
                    let para = Object.assign({}, this.editMoneyForm);
                    let url = 'user/updateMoney.do';
                    requestPost(this, url, para).then((res) => {
                        NProgress.done();
                        if (res != '') {
                            util.successTip(this);
                            this.$refs['editMoneyForm'].resetFields();
                            this.editMoneyFormVisible = false;
                            this.filters.userType = 2;
                            this.getUsers();
                        }

                    });
                });
            },

            editSubmit: function () {

                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.editForm);
                            let url = 'user/update.do';
                            requestPost(this, url, para).then((res) => {
                                this.editLoading = false;
                                NProgress.done();
                                if (res != '') {
                                    util.successTip(this);
                                    this.$refs['editForm'].resetFields();
                                    this.editFormVisible = false;
                                    this.filters.userType = this.editForm.userType;
                                    this.getUsers();
                                }

                            });
                        });

            },


            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            let url = 'user/add.do';
                            //para.birth = (!para.birth || para.birth == '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
                            requestPost(this, url, para).then((res) => {
                                this.addLoading = false;
                                NProgress.done();
                                if (res !== '') {
                                    util.successTip(this);
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.filters.userType = this.addForm.userType;
                                    this.getUsers();
                                }
                            });
                        });
                    }
                });
            },

            selsChange: function (sels) {
                this.sels = sels;
            }

        },
        mounted() {

            this.filters.userType=0;
            this.getUsers();
        },
        activated: function () {

        }
    }

</script>


<style scope lang="scss" type="text/scss">
    @import '../../styles/vars.scss';
</style>


// WEBPACK FOOTER //
// admin.vue?2f568f0f